// extracted by mini-css-extract-plugin
module.exports = {"root":"Labeled_root__2zfTU","label":"Labeled_label__1yQcr","divider":"Labeled_divider__3YzOq"};